'use client';

import { useTranslations } from 'next-intl';
import { ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/cn';
import { OrderMageLogo } from '@/shared/ui/ordermage-logo';
import './ordermage-branding.scss';

type Props = ComponentPropsWithRef<'div'> & {
    onLogoClick?: () => void;
};
export const OrderMageBranding = ({ onLogoClick, className, ...props }: Props) => {
    const t = useTranslations();

    return (
        <div className={cn('ordermage-branding', className)} {...props}>
            <span data-testid="ordermage-branding-text">{t('WORDS.ORDERMAGE_PROVIDING')}</span>
            <button type="button" onClick={onLogoClick} data-testid="ordermage-branding-button">
                <OrderMageLogo aria-label="ordermage-logo" height={20} />
            </button>
        </div>
    );
};
